<div class="bl-user-button"> 
  <a class="user" (click)="menu4.toggle($event)" [title]="user.displayName">
    <span *ngIf="user?.mail"  class="bl-user-button__email">{{user.mail}}</span>
    <span  *ngIf="user?.mail === ''" class="bl-user-button__email"></span>
    <i class="pi pi-user"></i>
  </a>
  <p-menu #menu4 [model]="items" [popup]="true" appendTo="body" />
</div>
